(function () {
  function csFindProductForm(container) {
    var formId = container.dataset.csProductFormId;

    if (formId) {
      var formById = document.getElementById(formId);

      if (formById) {
        return formById;
      }
    }

    var section = container.closest('.shopify-section');

    if (section) {
      var sectionForm = section.querySelector('form[action*="/cart/add"]');

      if (sectionForm) {
        return sectionForm;
      }
    }

    return document.querySelector('form[action*="/cart/add"]');
  }

  function csGetHiddenInput(form, propertyName) {
    var inputName = 'properties[' + propertyName + ']';
    var hiddenInput = form.querySelector('input[name="' + CSS.escape(inputName) + '"]');

    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = inputName;
      hiddenInput.setAttribute('data-cs-personalization-hidden', 'true');
      form.appendChild(hiddenInput);
    }

    return hiddenInput;
  }

  function csSyncValue(visibleInput, hiddenInput) {
    hiddenInput.value = visibleInput.value.trim();
  }

  function csValidate(container, visibleInput) {
    var isRequired = container.dataset.csRequired === 'true';

    if (!isRequired) {
      return true;
    }

    if (visibleInput.value.trim()) {
      visibleInput.setCustomValidity('');
      return true;
    }

    visibleInput.setCustomValidity('Please enter personalization text.');
    visibleInput.reportValidity();

    return false;
  }

  function csInitPersonalization(container) {
    if (!container || container.dataset.csInitialized === 'true') return;

    var visibleInput = container.querySelector('[data-cs-personalization-input]');
    var propertyName = container.dataset.csPropertyName || 'Personalization';
    var form = csFindProductForm(container);

    if (!visibleInput || !form) return;

    var hiddenInput = csGetHiddenInput(form, propertyName);

    csSyncValue(visibleInput, hiddenInput);

    visibleInput.addEventListener('input', function () {
      visibleInput.setCustomValidity('');
      csSyncValue(visibleInput, hiddenInput);
    });

    visibleInput.addEventListener('change', function () {
      csSyncValue(visibleInput, hiddenInput);
    });

    form.addEventListener('submit', function (event) {
      csSyncValue(visibleInput, hiddenInput);

      if (!csValidate(container, visibleInput)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    var addButtons = form.querySelectorAll(
      'button[type="submit"], button[name="add"], input[type="submit"]'
    );

    addButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        csSyncValue(visibleInput, hiddenInput);

        if (!csValidate(container, visibleInput)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    });

    container.dataset.csInitialized = 'true';
  }

  function csInitAllPersonalization(scope) {
    var fields = (scope || document).querySelectorAll('[data-cs-personalization]');

    fields.forEach(function (field) {
      csInitPersonalization(field);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    csInitAllPersonalization(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    csInitAllPersonalization(event.target);
  });
})();